var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopBackButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.364,
    height: 17,
    viewBox: "0 0 55.364 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(-360.5 -139)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Back",
    transform: "translate(379.864 153)",
    fill: "#101820",
    fontSize: 16,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Back")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-left",
    "data-name": "Icon awesome-arrow-left",
    d: "M8.253,15.71l-.712.712a.766.766,0,0,1-1.087,0L.222,10.192a.766.766,0,0,1,0-1.087L6.455,2.873a.766.766,0,0,1,1.087,0l.712.712a.77.77,0,0,1-.013,1.1L4.377,8.365h9.214a.768.768,0,0,1,.769.769V10.16a.768.768,0,0,1-.769.769H4.377L8.24,14.61A.765.765,0,0,1,8.253,15.71Z",
    transform: "translate(360.503 138.353)",
    fill: "#101"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopBackButton);
export default __webpack_public_path__ + "static/media/desktopBackButton.762062713b5ef3eb5ce2ab4aef7cd3d3.svg";
export { ForwardRef as ReactComponent };